module.exports = __webpack_public_path__ + "static/media/4_screen.d5c06bb9.png";